import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { Acompanhamento, ModalAcompanhamentoACVProps } from "./Types";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";
import ModalChecklistACV from "./ModalChecklistACV";

const ModalAcompanhamentoACV: React.FC<ModalAcompanhamentoACVProps> = ({ cicloSelecionando, onClose }) => {
    const [acompanhamento, setAcompanhamento] = useState<Acompanhamento>({
        ciclo: cicloSelecionando?.ciclo_isaga || "",
        responsavel: cicloSelecionando?.matricula || "",
        valvulaFechada: "",
        termopar1Linha: "",
        termopar1Posicao: "",
        termopar2Linha: "",
        termopar2Posicao: "",
    });

    const [isReadonly, setIsReadonly] = useState(false);
    const [checklistOpen, setChecklistOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checklistData, setChecklistData] = useState([]);



    const clearAcompanhamento = () => {
        setAcompanhamento({
            ciclo: cicloSelecionando?.ciclo_isaga || "",
            responsavel: "",
            valvulaFechada: "",
            termopar1Linha: "",
            termopar1Posicao: "",
            termopar2Linha: "",
            termopar2Posicao: "",
        });
    };

    const handleCheckList = async () => {
        try {
            const response = await blogFetch.get(`iSAGA_ACV_Acompanhamento/checklist-acv/${cicloSelecionando?.ciclo_isaga}`);
            setChecklistData(response.data);
        } catch (error) {
            console.error("Erro ao buscar checklist:", error);
        }
    };

    const handleSaveApontamento = async () => {
        setLoading(true);
        try {
            await blogFetch.post("iSAGA_ACV_Acompanhamento/acompanhamento", acompanhamento);
            toast.success("Acompanhamento salvo com sucesso!");
            clearAcompanhamento();
            onClose();
        } catch (error) {
            console.error("Erro ao salvar acompanhamento:", error);
            toast.error("Erro ao salvar acompanhamento.");
        } finally {
            setLoading(false);
        }
    };

    const isAcompanhamentoCompleto = () => {
        return (
            acompanhamento.responsavel &&
            acompanhamento.valvulaFechada &&
            acompanhamento.termopar1Linha &&
            acompanhamento.termopar1Posicao &&
            acompanhamento.termopar2Linha &&
            acompanhamento.termopar2Posicao
        );
    };

    useEffect(() => {
        const fetchAcompanhamento = async () => {
            if (!cicloSelecionando) return;
            setLoading(true);

            try {
                const response = await blogFetch.get(
                    `iSAGA_ACV_Acompanhamento/acompanhamento/${cicloSelecionando.ciclo_isaga}`
                );
                const data = response.data;

                if (!data) {
                    setAcompanhamento((p) => ({ ...p, ciclo: cicloSelecionando.ciclo_isaga }));
                    return;
                } else {
                    setIsReadonly(true);
                }

                setAcompanhamento({
                    ciclo: data.acomp_Ciclo || "",
                    responsavel: data.acomp_Responsavel || "",
                    valvulaFechada: data.acomp_ValvulaFechada || "",
                    termopar1Linha: data.acomp_NumLinTermopar1 || "",
                    termopar1Posicao: data.acomp_PosicaoTermopar1 || "",
                    termopar2Linha: data.acomp_NumLinTermopar2 || "",
                    termopar2Posicao: data.acomp_PosicaoTermopar2 || "",
                });
            } catch (error) {
                console.error("Erro ao buscar acompanhamento:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchAcompanhamento();
        handleCheckList();
    }, [cicloSelecionando || checklistOpen]);


    return (
        <div className="p-4 bg-white rounded-3">
            {/* Cabeçalho */}
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-4">
                <h4 className="fw-bold text-primary mb-0">Acompanhamento de Ciclo - Autoclave</h4>
                <Button variant="close" onClick={onClose} />
            </div>

            {/* Informações Gerais */}
            <section className="mb-4 p-3 bg-light border rounded-2">
                <h6 className="fw-bold text-primary mb-3">Informações Gerais</h6>
                <Row className="gy-3">
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="fw-bold small">Nº Ciclo</Form.Label>
                            <Form.Control size="sm" value={cicloSelecionando?.ciclo_isaga} disabled className="bg-light" />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="fw-bold small">Responsável</Form.Label>
                            <Form.Control
                                size="sm"
                                type="text"
                                value={acompanhamento.responsavel}
                                onChange={(e) => setAcompanhamento((p) => ({ ...p, responsavel: e.target.value }))}
                                disabled={isReadonly}
                                className="border-2"
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="fw-bold small">Válvulas Fechadas</Form.Label>
                            <Form.Control
                                size="sm"
                                type="text"
                                value={acompanhamento.valvulaFechada || ""}
                                disabled={isReadonly}
                                onChange={(e) =>
                                    setAcompanhamento((p) => ({
                                        ...p,
                                        valvulaFechada: e.target.value
                                    }))
                                }
                                className="border-2"
                            />
                        </Form.Group>
                    </Col>


                </Row>
            </section>

            {/* Termopares */}
            <section className="mb-4 p-3 bg-light border rounded-2">
                <h6 className="fw-bold text-primary mb-3 text-center">Termopares</h6>
                <Row className="gy-3">
                    {[
                        {
                            label: "Nº Linha Termopar 1",
                            key: "termopar1Linha",
                            options: ["Vidro-1", "Vidro-2", "Vidro-3", "Vidro-4", "Vidro-5", "Vidro-6", "Vidro-7", "Vidro-8"]
                        },
                        {
                            label: "Posição Termopar 1",
                            key: "termopar1Posicao",
                            options: ["Porta Alto", "Porta Baixo", "Fundo Alto", "Fundo Baixo"]
                        },
                        {
                            label: "Nº Linha Termopar 2",
                            key: "termopar2Linha",
                            options: ["Vidro-1", "Vidro-2", "Vidro-3", "Vidro-4", "Vidro-5", "Vidro-6", "Vidro-7", "Vidro-8"]
                        },
                        {
                            label: "Posição Termopar 2",
                            key: "termopar2Posicao",
                            options: ["Porta Alto", "Porta Baixo", "Fundo Alto", "Fundo Baixo"]
                        },
                    ].map(({ label, key, options }) => (
                        <Col md={3} key={key}>
                            <Form.Group>
                                <Form.Label className="fw-bold small">{label}</Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={(acompanhamento as any)[key] || ""}
                                    disabled={isReadonly}
                                    onChange={(e) =>
                                        setAcompanhamento((prev) => ({
                                            ...prev,
                                            [key]: e.target.value,
                                        }))
                                    }
                                    className="border-2">
                                    <option value="">Selecione</option>
                                    {options.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    ))}
                </Row>
            </section>

            {/* Checklist */}
            <section className="mb-4 p-3 bg-light border rounded-2">
                <h6 className="fw-bold text-primary mb-3">Checks Realizados</h6>
                {Array.isArray(checklistData) && checklistData.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle mb-0">
                            <thead className="bg-primary text-white">
                                <tr>
                                    <th className="fw-bold small">Horário</th>
                                    <th className="fw-bold small">Operador</th>
                                    <th className="fw-bold small text-center">Pressão OK</th>
                                    <th className="fw-bold small">Pressão SP</th>
                                    <th className="fw-bold small">Pressão PV</th>
                                    <th className="fw-bold small text-center">Vácuo OK</th>
                                    <th className="fw-bold small">Vácuo PV</th>
                                    <th className="fw-bold small text-center">Temp. OK</th>
                                    <th className="fw-bold small">Temp. SP</th>
                                    <th className="fw-bold small">Temp. PV</th>
                                    <th className="fw-bold small text-center">Gráfico OK</th>
                                    <th className="fw-bold small">Problemas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(checklistData as any[]).map((item, i) => (
                                    <tr key={item?.acompInsp_Key ?? i}>
                                        <td className="small text-muted">
                                            {item?.acompInsp_Horario
                                                ? new Date(item.acompInsp_Horario).toLocaleString()
                                                : "-"}
                                        </td>
                                        <td className="small">{item?.acompInsp_Operador ?? "-"}</td>
                                        <td className="text-center">{item?.acompInsp_PressaoOK ? "✅" : "❌"}</td>
                                        <td className="small">{item?.acompInsp_PressaoSP ?? "-"}</td>
                                        <td className="small">{item?.acompInsp_PressaoPV ?? "-"}</td>
                                        <td className="text-center">{item?.acompInsp_VacuoOK ? "✅" : "❌"}</td>
                                        <td className="small">{item?.acompInsp_VacuoPV ?? "-"}</td>
                                        <td className="text-center">{item?.acompInsp_TemperaturaOK ? "✅" : "❌"}</td>
                                        <td className="small">{item?.acompInsp_TemperaturaSP ?? "-"}</td>
                                        <td className="small">{item?.acompInsp_TemperaturaPV ?? "-"}</td>
                                        <td className="text-center">{item?.acompInsp_GraficoProvetaOK ? "✅" : "❌"}</td>
                                        <td className="text-break small" style={{ maxWidth: 150 }}>
                                            {item?.acompInsp_Problemas ?? "-"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-muted text-center py-3">Nenhum check disponível</div>
                )}
            </section>

            {/* Botões */}
            <div className="d-flex justify-content-between align-items-center pt-3 border-top">
                <Button variant="outline-primary" className="fw-bold" disabled={!isAcompanhamentoCompleto()} onClick={() => setChecklistOpen(true)}>
                    🧾 Abrir Checklist
                </Button>

                <div className="d-flex gap-2">
                    <Button variant="success" className="fw-bold" disabled={loading} onClick={handleSaveApontamento}>
                        {loading ? <Spinner size="sm" animation="border" className="me-2" /> : ""}Salvar
                    </Button>
                    <Button variant="outline-secondary" className="fw-bold" onClick={clearAcompanhamento}>
                        Limpar
                    </Button>
                    <Button variant="outline-danger" className="fw-bold" onClick={onClose}>
                        Fechar
                    </Button>
                </div>
            </div>

            <ModalChecklistACV
                checklistOpen={checklistOpen}
                setChecklistOpen={setChecklistOpen}
                ciclo_isaga={acompanhamento.ciclo || ""}
                onChecklistSaved={handleCheckList}
            />
        </div>
    );
};

export default ModalAcompanhamentoACV;
